import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import aluAluPackagingImg from "../../assets/Images/packaging/alu-alu-packaging.png";
import sachetsPackagingImg from "../../assets/Images/packaging/sachets-packaging.png";
import blisterPackingImg from "../../assets/Images/packaging/blister-Packing.png";
import cosmeticsPackagingImg from "../../assets/Images/packaging/cosmetics-packaging.png";
import bottlePackagingImg from "../../assets/Images/packaging/bottle-packaging.png";
import effPackagingImg from "../../assets/Images/packaging/eff-packaging.jpg";
import jarPackagingImg from "../../assets/Images/packaging/jar-packaging.png";
import proteinBarsImg from "../../assets/Images/packaging/protein-bars.png";

import 'swiper/css';

export default function SmartPackaging({
  packagingItems = [
    { id: 1, name: 'ALU-ALU PACKAGING', imageSrc: aluAluPackagingImg },
    { id: 2, name: 'SACHETS PACKAGING', imageSrc: sachetsPackagingImg },
    { id: 3, name: 'BLISTER PACKING', imageSrc: blisterPackingImg },
    { id: 4, name: 'COSMETICS PACKAGING', imageSrc: cosmeticsPackagingImg },
    { id: 5, name: 'BOTTLE PACKAGING', imageSrc: bottlePackagingImg },
    { id: 6, name: 'EFFERVESCENT PACKAGING', imageSrc: effPackagingImg },
    { id: 7, name: 'JAR PACKAGING', imageSrc: jarPackagingImg },
    { id: 8, name: 'PROTEIN BAR PACKAGING', imageSrc: proteinBarsImg },
  ],
  autoplayInterval = 3000,
}) {
  const [isPaused, setIsPaused] = useState(false);
  const [progressKey, setProgressKey] = useState(0);

  const brandGreen = '#335235';
  const bgGreen = '#899F87';

  return (
    <section
      className="w-full py-16 px-4 sm:px-6 lg:px-8 overflow-hidden"
      style={{ backgroundColor: bgGreen }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="mx-auto">

        {/* Title */}
        <h2 className="text-4xl font-medium text-[#1a2e18] text-center mb-10">
          SMART PACKAGING FOR SMARTER WELLNESS
        </h2>

        {/* Swiper Slider */}
        <div className="overflow-hidden">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
            loop={true}
            autoplay={{
              delay: autoplayInterval,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={600}
            onSlideChange={() => setProgressKey((k) => k + 1)}
          >
            {packagingItems.map((item) => (
              <SwiperSlide key={item.id} style={{ height: 'auto' }}>
                <div
                  className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300"
                  style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                >
                  {/* Fixed height image — increased to 320px */}
                  <div style={{ width: '100%', height: '320px', flexShrink: 0, overflow: 'hidden' }}>
                    {item.imageSrc ? (
                      <img
                        src={item.imageSrc}
                        alt=""
                        role="presentation"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gray-100">
                        <p className="text-xs text-gray-400 font-medium">No Image</p>
                      </div>
                    )}
                  </div>

                  {/* Product Name */}
                  <div
                    style={{
                      padding: '14px 16px',
                      textAlign: 'center',
                      minHeight: '52px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <h3
                      className="text-xs sm:text-sm font-bold tracking-wide"
                      style={{ color: brandGreen }}
                    >
                      {item.name}
                    </h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Progress underline only — no dots */}
        <div className="flex justify-center mt-8">
          <div className="w-24 h-[3px] bg-white/30 rounded-full overflow-hidden">
            <div
              key={progressKey}
              className="h-full bg-white rounded-full origin-left"
              style={{
                width: '100%',
                transform: 'scaleX(0)',
                animation: `pkgProgress ${autoplayInterval}ms linear forwards`,
                animationPlayState: isPaused ? 'paused' : 'running',
                willChange: 'transform',
              }}
            />
          </div>
        </div>

      </div>

      <style jsx global>{`
        .swiper-slide {
          height: auto !important;
        }
        @keyframes pkgProgress {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}</style>
    </section>
  );
}